import styled from 'styled-components';
import { Col, Row } from 'components/Core/Grid';

export const LoggedInUserContainer = styled.div`
  width: ${({ hasImage }) => (hasImage ? 'auto' : '375px')};

  @media (max-width: 767px) {
    width: ${({ hasImage }) => (hasImage ? 'auto' : '375px')};
  }

  background-color: white;
  padding: 25px 20px 25px 20px;
  color: black;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);

  > p {
    margin-bottom: 10px;
  }
`;

export const LoggedInUserRow = styled(Row)`
  padding: 16px 20px 16px 20px;
  border: solid 1px var(--grey-3);
  border-radius: 4px;
  margin-bottom: 25px;
`;

export const LoggedInUserCol = styled(Col)`
  display: flex;
  align-self: center;
  > div {
    margin-right: 20px;
  }
  > p {
    margin: auto 0 auto 0;
    display: block;
  }
`;
